import React,{ Component } from 'react';
import $ from 'jquery';
import { useNavigate } from "react-router-dom";

class MainHeader extends Component {
	constructor(props) {
        super(props);
	 	this.state ={

	 	}
    }
   	
	logout = () => {
		localStorage.removeItem("accessToken");
		localStorage.removeItem("user");
		window.location.href = "/login";
    }
	
    render(){
		const { builderOption } =this.props;
    	return (
        <div className="card-header top-header">
            <div className="row">
				<div className="col-md-6 col-6">
                    <h4>Task Master</h4>
					<div className="instance-version">{'V1.02182025.a'}</div> 
                </div>
				<div className="col-md-6 col-6 text-right top-right-login">
                   <div className="login-user-top">{'Logged in as: '+localStorage.getItem('username')}</div>
                </div>
				<div className="col-md-2 col-8">
					{localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin' ?
					<select id="select-view-option" className="form-control company-select" onChange={builderOption} >
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="taskManager">Task List Builder</option>
						:null}
						
						<option value="workFlow">Workflow Builder</option>
						<option value="workFlowDetails">Workflow Details</option>
						<option value="workFlowProgress">Workflows in Progress</option>
						<option value="scheduledworkFlow">Scheduled Workflows</option>
						<option value="workFlowManager">Workflow Manager</option>
						
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="userManager">User Manager</option>
						:null}
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="goToTask">Go-to Task</option>
						:null}
						
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="goToValues">Go-to Link Values</option>
						:null}
						
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="goToManager">Go-to Link manager</option>
						:null}
						
						{localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin' ?
						<option value="workflowStart">Start a Workflow</option>
						:null}
						
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="companyManager">Company Manager</option>
						:null}
						
						{localStorage.getItem('qrcode') == 1 ?
						<option value="qrManager">QR Generator</option>
						:null}
						
						{localStorage.getItem('role') == 'SuperAdmin' ?
						<option value="keyManager">API Key Manager</option>
						:null}
						
						{localStorage.getItem('feeguide') == 1 ?
						<option value="feeManager">Fee Guide Management</option>
						:null}
					</select>
					:null}
					
					{localStorage.getItem('role') == 'FeeAdmin' || localStorage.getItem('role') == 'FeeUser' ?
					<select id="select-view-option" className="form-control company-select" onChange={builderOption} >
						<option value="">Select Mode</option>
						{localStorage.getItem('feeguide') == 1 ?
						<option value="feeManager">Fee Guide Management</option>
						:null}
					</select>
					:null}
					
					{localStorage.getItem('role') == 'Subscriber' ?
					<select id="select-view-option" className="form-control company-select" onChange={builderOption} >
						<option value="workFlowProgress">Workflows in Progress</option>
					</select>
					:null}
					
					{localStorage.getItem('role') == 'General' ?
					<select id="select-view-option" className="form-control company-select" onChange={builderOption} >
						<option value="goToTask">Go-to Task</option>
					</select>
					:null}
					
				</div>
				<div className="col-md-4 col-4 user-top-outer">
					<div className="login-user-top">{'Logged in as: '+localStorage.getItem('username')}</div>
					<a className="btn btn-outline-info sign-out-btn" onClick={this.logout}>Sign Out</a>
                </div>
            </div>
        </div>            
    )}
	
}

export default MainHeader;